import { QPoint } from "./QPoint";
import { QPublishScalerPage } from "./QPublishScalerPage";
import { QRect } from "./QRect";
import { enumOptimizedMode } from "../constants";
import { Globals } from "./Globals";

export class QPublishScaler {
  constructor() {
    this.fPageList = null;
    this.fMaxScaleToBase = null;
    this.fForceAspectRatio = null;
    this.fMaxPage = null;
    this.fBasePage = null;
    this.fOptimizedMode = enumOptimizedMode.enumForPrint;
  }

  InitScaler(forceAspectRatio, optimizedMode) {
    this.fForceAspectRatio = forceAspectRatio;
    this.fPageList = [];
    this.fMaxScaleToBase = 1.0;
    this.fScaleToBase = 1.0;
    this.fMaxPage = { x: Number.POSITIVE_INFINITY, y: Number.POSITIVE_INFINITY };
    this.fBasePage = new QPublishScalerPage();
    this.fBasePage.InitPage(0, 0, { x: 0, y: 0 }, 1);
    this.fOptimizedMode = optimizedMode;
  }

  //=======================================================================================
  // Inputs:
  //      * MarginRect - QRect(left,top,right,bottom) - Example: 48 Pixels
  //      * BasePageSize - Example: 1056 X 816
  SetBasePageProps(sizeX, sizeY, maxX, maxY, marginRect) {
    var pageSize = { fX: sizeX, fY: sizeY };
    this.CorrectForAspectRatio(pageSize);
    this.fBasePage.InitPage(pageSize.fX, pageSize.fY, marginRect, 1);

    if (maxX !== null) {
      this.fMaxPage.x = maxX;
    }

    if (maxY !== null) {
      this.fMaxPage.y = maxY;
    }
  }

  // Pages will be added in order
  AddPage(sizeX, sizeY) {
    // special case of pdf where aspect ratio of base page is to be ignored
    if (this.fOptimizedMode === enumOptimizedMode.enumForScreen) {
      this.fBasePage.fPageX = sizeX;
      this.fBasePage.fPageY = sizeY;
    }

    var aPage = new QPublishScalerPage();
    var marginX = this.fBasePage.fMargin.fLeft + this.fBasePage.fMargin.fRight;
    var marginY = this.fBasePage.fMargin.fTop + this.fBasePage.fMargin.fBottom;
    var shrinkFactor = 1;
    var pageSize = { fX: sizeX, fY: sizeY };
    shrinkFactor =
      shrinkFactor *
      Math.min(
        (this.fBasePage.fPageX - marginX) / (pageSize.fX - marginX),
        (this.fBasePage.fPageY - marginY) / (pageSize.fY - marginY)
      );
    aPage.InitPage(pageSize.fX, pageSize.fY, this.fBasePage.fMargin, shrinkFactor);
    this.fPageList.push(aPage);
    this.fMaxScaleToBase = Math.max(
      this.fMaxScaleToBase,
      pageSize.fX / this.fBasePage.fPageX,
      pageSize.fY / this.fBasePage.fPageY
    );

    var x = Math.floor(this.fMaxScaleToBase * this.fBasePage.fPageX);
    if (x > this.fMaxPage.x) {
      this.fMaxScaleToBase = this.fMaxScaleToBase * (this.fMaxPage.x / x);
    }

    var y = Math.floor(this.fMaxScaleToBase * this.fBasePage.fPageY);
    if (y > this.fMaxPage.y) {
      this.fMaxScaleToBase = this.fMaxScaleToBase * (this.fMaxPage.y / y);
    }
  }

  //=======================================================================================
  // Outputs:
  GetOutputPageSize() {
    // This includes the margins
    var page_size = new QPoint();
    page_size.InitPoint(
      Math.floor(this.fMaxScaleToBase * this.fBasePage.fPageX),
      Math.floor(this.fMaxScaleToBase * this.fBasePage.fPageY)
    );

    return page_size;
  }

  GetOutputMargins() {
    var outputMargin = new QRect();
    outputMargin.InitRect(
      Math.round(this.fMaxScaleToBase * this.fBasePage.fMargin.fLeft),
      Math.round(this.fMaxScaleToBase * this.fBasePage.fMargin.fTop),
      Math.round(this.fMaxScaleToBase * this.fBasePage.fMargin.fRight),
      Math.round(this.fMaxScaleToBase * this.fBasePage.fMargin.fBottom)
    );
    return outputMargin;
  }

  GetContentScaleFactor(pageIndex) {
    var scaleFactor = 1.0;

    if (typeof pageIndex == "string")
      pageIndex = parseInt(pageIndex.substring(1)) + Globals._bookRenderInfo.fBranchPages;

    if (Globals._pubSettings.fUniformScaling) {
      //scaleFactor = this.fPageList.map(function(a){return a.fShrinkFactor})
      var scaleFactors = this.fPageList.map(function (a) {
        return a.fShrinkFactor;
      });
      var minFactor = Math.min.apply(null, scaleFactors);
      //scaleFactor = 1/this.fMaxScaleToBase;
      scaleFactor = minFactor * this.fMaxScaleToBase;
    } else if (pageIndex >= 0 && pageIndex < this.fPageList.length) {
      var aPage = this.fPageList[pageIndex];
      scaleFactor = aPage.fShrinkFactor * this.fMaxScaleToBase;
    }
    return scaleFactor;
  }

  GetContentPageSize(pageIndex) {
    var o_page_size = this.GetOutputPageSize();
    var margin = this.GetOutputMargins();
    var page_size = new QPoint();
    page_size.fX = o_page_size.fX - margin.fLeft - margin.fRight;
    page_size.fY = o_page_size.fY - margin.fTop - margin.fBottom;
    return page_size;
  }

  CorrectForAspectRatio(pageSize) {
    if (this.fForceAspectRatio) {
      var desiredAspectRatio = this.fForceAspectRatio.fX / this.fForceAspectRatio.fY;
      var aspectRatio = pageSize.fX / pageSize.fY;
      if (aspectRatio > desiredAspectRatio) {
        pageSize.fY = Math.round(pageSize.fX / desiredAspectRatio);
      }

      if (aspectRatio < desiredAspectRatio) {
        pageSize.fX = Math.round(pageSize.fY * desiredAspectRatio);
      }
    }
  }

  GetMinPageSize(pageIndex) {
    var pageSize = new QPoint();
    pageSize.InitPoint(this.fBasePage.fPageX, this.fBasePage.fPageY);
    return pageSize;
  }

  GetContentShiftCorrection(pageIndex) {
    var p = new QPoint();
    p.InitPoint(0, 0); //margin.fLeft, margin.fTop); // 1056 X 816
    if (typeof pageIndex == "string") {
      pageIndex = parseInt(pageIndex.substring(1)) + Globals._bookRenderInfo.fBranchPages;
    }
    if (pageIndex >= 0 && pageIndex < this.fPageList.length) {
      var mScale = this.GetMasterScaleFactor();

      var newMarginX = this.fBasePage.fMargin.fLeft * mScale;
      var newMarginY = this.fBasePage.fMargin.fTop * mScale;
      p.InitPoint(newMarginX, newMarginY);
    }

    return p;
  }

  GetMasterScaleFactor() {
    return this.fMaxScaleToBase;
  }

  GetMasterShiftFactor() {
    // This includes the margins
    var margin = this.GetOutputMargins();
    var m = new QPoint();
    m.InitPoint(0, 0); //margin.fLeft, margin.fTop); // 1056 X 816
    return m;
  }
}
